import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const MinusIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M2 8c0-.552.56-1 1.25-1h9.5c.69 0 1.25.448 1.25 1s-.56 1-1.25 1h-9.5C2.56 9 2 8.552 2 8Z", fill: "currentColor" })));
});
MinusIcon.displayName = 'MinusIcon';
export default MinusIcon;
